import { useTranslation } from 'react-i18next';

import '../../i18next';

//import nosotros from '../../assets/images/collage_nosotros.png';
import nosotros from '../../assets/images/Nosotros/nosotros2.png'

function Nosotros3() {
    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <section className="relative mr-10 ml-10 mt-4">
            <div className='flex justify-center items-center'>
                <img className="object-cover w-full" src={nosotros} alt="Nosotros" />
            </div>
        </section>
    );
}

export default Nosotros3;
